import { createSelector } from '@ngrx/store';
import { selectFilterFeature } from '../feature-selector';

const selectFilterPanelState = createSelector(selectFilterFeature, (featureState) => featureState.filterPanel);

export const FilterPanelSelectors = {
  selectOpenState: createSelector(selectFilterPanelState, (state) => state.isOpen && !!state.currentFilterInstanceId),
  selectCurrentInstanceId: createSelector(selectFilterPanelState, (state) => state.currentFilterInstanceId),
  selectIsInitialized: createSelector(selectFilterPanelState, (featureState) => !!featureState.currentFilterInstanceId)
};
